// Palette de couleurs agricoles pour distinguer les propriétaires / cultures.
export const PARCEL_PALETTE = [
  "#1a4731", // vert profond
  "#e8c872", // blé chaud
  "#3a7d44", // vert prairie
  "#b5651d", // terre cuite
  "#5b8c5a", // olive
  "#c0392b", // rouge brique
  "#2c6e91", // bleu rivière
  "#8e5572", // prune
  "#d98e04", // moutarde
  "#6b4226", // brun labour
];

// Couleur déterministe à partir d'une chaîne (propriétaire / culture).
export function colorForKey(key) {
  const str = (key || "—").toString();
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return PARCEL_PALETTE[hash % PARCEL_PALETTE.length];
}
